import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The AWSDateTime scalar type provided by AWS AppSync, represents a valid extended ISO 8601 DateTime string. In other
   * words, this scalar type accepts datetime strings of the form YYYY-MM-DDThh:mm:ss.SSSZ. The scalar can also accept
   * "negative years" of the form -YYYY which correspond to years before 0000. For example, "-2017-01-01T00:00Z" and
   * "-9999-01-01T00:00Z" are both valid datetime strings. The field after the two digit seconds field is a nanoseconds f
   * ield. It can accept between 1 and 9 digits. So, for example, "1970-01-01T12:00:00.2Z", "1970-01-01T12:00:00.277Z" and
   * "1970-01-01T12:00:00.123456789Z" are all valid datetime strings. The seconds and nanoseconds fields are optional
   * (the seconds field must be specified if the nanoseconds field is to be used). The time zone offset is compulsory for
   * this scalar. The time zone offset must either be Z (representing the UTC time zone) or be in the format ±hh:mm:ss.
   * The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard.
   */
  AWSDateTime: { input: any; output: any; }
  /**
   * The AWSJSON scalar type provided by AWS AppSync, represents a JSON string that complies with RFC 8259. Maps like
   * "{\"upvotes\": 10}", lists like "[1,2,3]", and scalar values like "\"AWSJSON example string\"", "1", and "true"
   * are accepted as valid JSON and will automatically be parsed and loaded in the resolver mapping templates as Maps,
   * Lists, or Scalar values rather than as the literal input strings. Invalid JSON strings like "{a: 1}", "{'a': 1}"
   * and "Unquoted string" will throw GraphQL validation errors.
   */
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  /**
   * The AWSURL scalar type provided by AWS AppSync, represents a valid URL string (Ex: https://www.amazon.com/). The URL
   * may use any scheme and may also be a local URL (Ex: http://localhost/). URLs without schemes like "amazon.com" or
   * "www.amazon.com" are considered invalid. URLs which contain double slashes (two consecutive forward slashes) in
   * their path are also considered invalid.
   */
  AWSURL: { input: any; output: any; }
};

export type Archive = {
  __typename?: 'Archive';
  /** If restore_state=RESTORED this field has ISO formatted timestamp with timezone offset */
  expiration?: Maybe<Scalars['String']['output']>;
  /** Extra archive info which usually requires additional requests to access */
  extra?: Maybe<ExtraArchiveInfo>;
  /** Restoration state of the object if any */
  restore_state: RestoreState;
};

/** Represents a condition in a statement. */
export type Condition = {
  __typename?: 'Condition';
  /** The condition key, such as "input.vtk_template". */
  key: Scalars['String']['output'];
  /** The condition operator, such as "StringLike". */
  operator: Scalars['String']['output'];
  /** The condition value. */
  values: Array<Scalars['String']['output']>;
};

export type CopyFileInput = {
  /** ID of the destination file. Typically expressed as S3 URL */
  dest: Scalars['String']['input'];
  /** ID of the source file. Typically expressed as S3 URL */
  src: Scalars['String']['input'];
};

export enum CrdDrmMode {
  Audio = 'AUDIO',
  Av = 'AV',
  Clear = 'CLEAR',
  Video = 'VIDEO'
}

export type CrdDrmSession = {
  __typename?: 'CrdDrmSession';
  /** Present iff mode is AUDIO or AV. */
  audio?: Maybe<CrdDrmTrack>;
  /** DRMtoday environment (production); null iff mode is CLEAR. */
  environment?: Maybe<Scalars['String']['output']>;
  /** rtc-drm-transform mediaBufferMs (target latency of the player's buffer, per env); null iff mode is CLEAR. */
  mediaBufferMs?: Maybe<Scalars['Int']['output']>;
  /** DRMtoday merchant (castlabs); null iff mode is CLEAR. */
  merchant?: Maybe<Scalars['String']['output']>;
  mode: CrdDrmMode;
  /** DRMtoday upfront token (x-dt-auth-token); null iff mode is CLEAR. */
  token?: Maybe<Scalars['String']['output']>;
  /** Re-fetch before this; null iff mode is CLEAR. */
  tokenExpiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Present iff mode is VIDEO or AV. */
  video?: Maybe<CrdDrmTrack>;
};

export type CrdDrmSessionInput = {
  hostInstance: Scalars['String']['input'];
  pool: Scalars['String']['input'];
  /** The monitor session from joinCrdSession's result ("<id>_m<monitor>"). */
  session: Scalars['String']['input'];
};

export type CrdDrmTrack = {
  __typename?: 'CrdDrmTrack';
  /** Always cbcs. */
  encryption: Scalars['String']['output'];
  /** IV, 32 hex digits. */
  iv: Scalars['String']['output'];
  /** Key id, 32 hex digits. */
  kid: Scalars['String']['output'];
};

/** Input type for the createUploadProcess mutation. */
export type CreateUploadTicketInput = {
  /**
   * The unique identifier for the new folder, expressed as a URL.
   * Example: s3://my-bucket/folder/new-folder
   */
  folder_id: Scalars['ID']['input'];
  /** Message for the uploader */
  message: Scalars['String']['input'];
};

export type DeleteInput = {
  deletionTime?: InputMaybe<DeletionTime>;
  /** ID of the file or folder to be deleted. E.g. s3://bucket/... */
  id: Scalars['ID']['input'];
};

export enum DeletionTime {
  InThreeDays = 'IN_THREE_DAYS',
  Now = 'NOW'
}

export type DesktopHost = {
  __typename?: 'DesktopHost';
  availabilityZone?: Maybe<Scalars['String']['output']>;
  awsRegion: Scalars['String']['output'];
  editingWorkspaces?: Maybe<Array<EditingWorkspace>>;
  instanceId: Scalars['ID']['output'];
  instanceType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Internet access: OPEN (after Setup, no workspace attached), SEALING (being cut off), SEALED (no TCP to the
   * internet; workspaces may be mounted). Null on a host that has not been through Setup or Mount since this existed.
   */
  network?: Maybe<Scalars['String']['output']>;
  pool?: Maybe<Scalars['String']['output']>;
  publicIp?: Maybe<Scalars['String']['output']>;
  /**
   * Number of screens (virtual displays on the desktop) the host streams, as the last Setup found them (EC2 tag
   * CrdScreens). Null on a host set up before Setup recorded it.
   */
  screens?: Maybe<Scalars['Int']['output']>;
  setupDate?: Maybe<Scalars['String']['output']>;
  /** Unified state: stopped, pending, stopping, not_registered, registered, in_use */
  state: Scalars['String']['output'];
};

export type DesktopHostsQueryInput = {
  /** Pool name. Governed by policy resources. */
  pool: Scalars['String']['input'];
};

export type DownloadUrlInput = {
  /** ID of the file. E.g. s3://bucket/path/filename.mp4 */
  file_id: Scalars['ID']['input'];
};

export type DownloadUrlPayload = {
  __typename?: 'DownloadUrlPayload';
  signed_url: Scalars['String']['output'];
};

/** Represents an editing workspace. */
export type EditingWorkspace = {
  __typename?: 'EditingWorkspace';
  /** Availability zone where the EBS volume is located. */
  availabilityZone?: Maybe<Scalars['String']['output']>;
  /** AWS region where the EBS volume is located. */
  awsRegion?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp when the session completed (only set for COMPLETED/FAILED). */
  completedAt?: Maybe<Scalars['Int']['output']>;
  /** Unix timestamp when the session was created. */
  createdAt: Scalars['Int']['output'];
  /** Drive letter assigned on the host (null if not mounted). */
  driveLetter?: Maybe<Scalars['String']['output']>;
  /** Error message if the session failed. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Unique workspace identifier (EBS volume ARN). */
  id: Scalars['ID']['output'];
  /** Mount point label for the editing workspace. */
  mountPoint?: Maybe<Scalars['String']['output']>;
  /** Instance ID the volume is currently mounted on (null if not mounted). */
  mountedOn?: Maybe<Scalars['String']['output']>;
  /** Pool this workspace belongs to. */
  pool?: Maybe<Scalars['String']['output']>;
  /** Current status of the session: RESOLVED, STAGING, WAITING_FOR_EDITOR, COPYING_BACK, COMPLETED, FAILED */
  status: Scalars['String']['output'];
  /** Size of the EBS volume in GiB. */
  volumeSizeGiB?: Maybe<Scalars['Int']['output']>;
};

/** Input type for the `createEditingWorkspace` mutation. */
export type EditingWorkspaceInput = {
  /**
   * Availability Zone for the EBS volume.
   * Must match the AZ of the EC2 editor instance.
   * The region will be derived from the availability zone.
   * Example: "eu-central-1b"
   */
  availabilityZone: Scalars['String']['input'];
  /** List of content IDs (S3 prefixes or IDs resolvable to S3 prefixes). */
  contents: Array<Scalars['ID']['input']>;
  /** Optional message shown to the editor when mounting the volume. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** A mount point name / label for identifying the editable workspace. */
  mountPoint: Scalars['String']['input'];
  /** Pool name. Governed by policy resources. */
  pool: Scalars['String']['input'];
};

export type EditingWorkspacesQueryInput = {
  /** Pool name. Governed by policy resources. */
  pool: Scalars['String']['input'];
  /** Optional filter by status. */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ExtraArchiveInfo = {
  __typename?: 'ExtraArchiveInfo';
  /** True if the object is in Deep Archive, whose restores take far longer than Glacier's. */
  deep_archive?: Maybe<Scalars['Boolean']['output']>;
  /** The restore's usual latest completion (request time + the tier's maximum), ISO 8601. S3 gives no real ETA. */
  restore_eta?: Maybe<Scalars['String']['output']>;
  /** When the restore was requested, ISO 8601. */
  restore_requested?: Maybe<Scalars['String']['output']>;
  restore_tier?: Maybe<RestoreTier>;
};

export type File = {
  __typename?: 'File';
  /** It's set for archived objects regardless where those are currently restored or not. otherwise it's not set. */
  archive?: Maybe<Archive>;
  /** If true the file is in long term storage and cannot be accessed immediately, else it is usable without taking any further action. */
  archived: Scalars['Boolean']['output'];
  /** True if deleted but not yet purged from storage. */
  deleted: Scalars['Boolean']['output'];
  /** Contains the extra stream-specific information. */
  extra_info?: Maybe<Scalars['AWSJSON']['output']>;
  /** Contains the streams property of the file's ffprobe output. */
  ffprobe?: Maybe<Array<Scalars['AWSJSON']['output']>>;
  /** ID of the file. E.g. s3://bucket/path/filename.mp4 */
  id: Scalars['ID']['output'];
  /** Date of last modification in ISO 8601 format. This can be considered to be the upload date/time. */
  last_modified: Scalars['AWSDateTime']['output'];
  /** Contains the mediainfo's textual output. */
  mediainfo?: Maybe<Scalars['String']['output']>;
  /** Contains the mediainfo's JSON representation of the file. */
  mediainfo_json?: Maybe<Array<Scalars['AWSJSON']['output']>>;
  /** Human-readable name of the file. Typically the last part of the file's ID */
  name: Scalars['String']['output'];
  /** Size of the file in bytes */
  size: Scalars['Float']['output'];
  /** Array of generated still images of the first video track of the file. */
  stills: Array<Maybe<Still>>;
  /** Tags assigned to the file. */
  tags?: Maybe<Array<Tag>>;
  /** Information about the file's tracks. */
  tracks?: Maybe<Array<Track>>;
  /** Contains the streams warnings - output of basic qc process. */
  warnings?: Maybe<Array<Scalars['AWSJSON']['output']>>;
};

export type FileInput = {
  /** ID of the file. E.g. s3://bucket/path/filename.mp4 */
  file_id: Scalars['ID']['input'];
};

export type FileOrFolder = File | Folder;

export type Folder = {
  __typename?: 'Folder';
  /** A list of all files within this folder. The `show_deleted` argument can be set to `true` to include deleted files that have not been purged from storage. */
  files: Array<File>;
  /** A list of all sub-folders within this folder. */
  folders: Array<Folder>;
  /** The unique ID of the folder, expressed as a S3 URL, e.g. s3://bucket/path. */
  id: Scalars['ID']['output'];
  /** Date of last modification within this subtree in ISO 8601 format e.g. latest upload under this prefix */
  last_modified: Scalars['AWSDateTime']['output'];
  /** A human-readable name for the folder, typically the last part of the folder's ID or short name of the bucket. */
  name: Scalars['String']['output'];
  /** A list of this folder's parent folders. */
  parents: Array<Folder>;
  /**
   * Security level of the folder's bucket: `default_security` or `prerelease_security`. Content from a
   * `prerelease_security` bucket may only be encoded with a forensic watermark. Null for a bucket without one.
   */
  security_level?: Maybe<Scalars['String']['output']>;
  /** A list of tags assigned to this folder. */
  tags?: Maybe<Array<Tag>>;
};


export type FolderFilesArgs = {
  show_deleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for the `previewGenerateToken` mutation, used to generate a token for accessing preview files. */
export type GeneratePreviewTokenInput = {
  /** The `asset_id` of the preview file set, as returned in the `data` property of the `previewGenerate` process. */
  asset_id?: InputMaybe<Scalars['String']['input']>;
};

export type Hit = {
  __typename?: 'Hit';
  SequenceNumber: Scalars['String']['output'];
  brefix: Scalars['String']['output'];
  extra_info?: Maybe<Scalars['AWSJSON']['output']>;
  ffprobe?: Maybe<Scalars['AWSJSON']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mediainfo?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  tracks?: Maybe<Array<Track>>;
  warnings?: Maybe<Scalars['AWSJSON']['output']>;
};

export type JoinCrdSessionInput = {
  hostInstance: Scalars['String']['input'];
  monitor?: InputMaybe<Scalars['Int']['input']>;
  pool: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

/** The input for the `mkdir` mutation, used to create a new folder in the underlying storage system. */
export type MkdirInput = {
  /**
   * The unique identifier for the new folder, expressed as a URL.
   * Example: s3://my-bucket/folder/new-folder
   */
  folder_id: Scalars['ID']['input'];
};

/** The return value of the mkdir permission, indicating whether a folder was created or not. */
export type MkdirPayload = {
  __typename?: 'MkdirPayload';
  /** A boolean indicating whether the folder was actually created (true) or already existed (false). */
  created?: Maybe<Scalars['Boolean']['output']>;
  /** The parent folder of the newly created folder, which can be used to update the client-side state. */
  parent: Folder;
};

export type MountEditingWorkspaceInput = {
  hostInstance: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  pool: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Trigger a copy process of a file to a new location. */
  copy_file: RepositoryProcessPayload;
  /**
   * Starts a remote editing session: creates an EBS volume, stages content,
   * and runs a long-running Step Functions workflow.
   */
  createEditingWorkspace: RepositoryProcessPayload;
  /** Creates a new upload ticket for a folder. The ticket can be used to upload files to the folder using the AWS S3 multipart upload API. */
  createUploadTicket: UploadTicketPayload;
  /** Delete a file. */
  delete: UpdateFilePayload;
  /** Generates a short lived download URL for eligable content */
  generateDownloadUrl: DownloadUrlPayload;
  /** Trigger generation of still images of the first video track of the file. */
  generate_stills: RepositoryProcessPayload;
  /**
   * Joins a CRD session: starts the host binary, sets a new Windows password,
   * creates client peer. Returns a process — poll for completion, then read
   * session info from process.data (JSON: session, password, signalServerUrl,
   * hostPeerId, clientPeerId).
   */
  joinCrdSession: RepositoryProcessPayload;
  /** Creates a directory. */
  mkdir: MkdirPayload;
  /**
   * Mounts an editing workspace EBS volume onto a CRD host instance.
   * Attaches the volume and assigns a drive letter via SSM.
   */
  mountEditingWorkspace: RepositoryProcessPayload;
  /** Trigger a move process of a file to a new location. */
  move_file: RepositoryProcessPayload;
  /** The previewGenerate process does generate the actual preview. */
  previewGenerate: RepositoryProcessPayload;
  /** Generates a short lived DRMtoday upfront auth token from an existing playback allowance generated by a previewGenerate Mutation. */
  previewGenerateToken: PreviewTokenPayload;
  /** The previewPrepare process performs preparatory steps to generate a preview for a folder. */
  previewPrepare: RepositoryProcessPayload;
  /** Internal: Publishes that a Process has been completed to message its subscriptions. */
  publishProcessComplete: RepositoryProcessPayload;
  /** Trigger a refresh of the basic QC of the file. */
  refreshBasicQc: UpdateFilePayload;
  /** Trigger a refresh of the extra data. */
  refreshExtra: UpdateFilePayload;
  /** Trigger a refresh of the ffprobe data. */
  refreshFFProbe: UpdateFilePayload;
  /** Trigger a refresh of the mediainfo and mediainfo_json properties. */
  refreshMediaInfo: UpdateFilePayload;
  /** Trigger a refresh of the tracks property. */
  refreshTracks: UpdateFilePayload;
  /** Registers a webhook to the process. */
  registerWebhook: RepositoryProcessPayload;
  /** Trigger restore of an archived file. */
  restore: RepositoryProcessPayload;
  /**
   * Sets up a CRD host: downloads the binary, installs virtual display and audio
   * drivers, reboots, and tags the instance with the setup date.
   * Run once at provisioning or when updating drivers or the host binary.
   */
  setupDesktopHost: RepositoryProcessPayload;
  /**
   * Starts a CRD (remote desktop) session: tags and starts an EC2 instance,
   * waits for the host agent to signal session end via task token callback.
   */
  startDesktopHost: RepositoryProcessPayload;
  stopDesktopHost: StopDesktopHostPayload;
  /** Apply tags to a folder. */
  tag_folder: TagFolderPayload;
  /** Undelete a file. */
  undelete: UpdateFilePayload;
  /**
   * Unmounts an editing workspace EBS volume from a CRD host instance.
   * Action determines what happens after unmount:
   * - UNMOUNT: just detach, keep volume for later remount
   * - COPY_BACK: detach, sync edited content to S3, then delete volume
   * - DELETE: detach and delete volume without copying back
   */
  unmountEditingWorkspace: RepositoryProcessPayload;
  /** Use to update mutable file info. */
  updateFile: UpdateFilePayload;
};


export type MutationCopy_FileArgs = {
  input: CopyFileInput;
};


export type MutationCreateEditingWorkspaceArgs = {
  input: EditingWorkspaceInput;
};


export type MutationCreateUploadTicketArgs = {
  input: CreateUploadTicketInput;
};


export type MutationDeleteArgs = {
  input?: InputMaybe<DeleteInput>;
};


export type MutationGenerateDownloadUrlArgs = {
  input: DownloadUrlInput;
};


export type MutationGenerate_StillsArgs = {
  input: RefreshInput;
};


export type MutationJoinCrdSessionArgs = {
  input: JoinCrdSessionInput;
};


export type MutationMkdirArgs = {
  input: MkdirInput;
};


export type MutationMountEditingWorkspaceArgs = {
  input: MountEditingWorkspaceInput;
};


export type MutationMove_FileArgs = {
  input: CopyFileInput;
};


export type MutationPreviewGenerateArgs = {
  input: PreviewGenerateInput;
};


export type MutationPreviewGenerateTokenArgs = {
  input: GeneratePreviewTokenInput;
};


export type MutationPreviewPrepareArgs = {
  input: PreviewPrepareInput;
};


export type MutationPublishProcessCompleteArgs = {
  result: ProcessInput;
};


export type MutationRefreshBasicQcArgs = {
  input: RefreshInput;
};


export type MutationRefreshExtraArgs = {
  input: RefreshInput;
};


export type MutationRefreshFfProbeArgs = {
  input: RefreshInput;
};


export type MutationRefreshMediaInfoArgs = {
  input: RefreshInput;
};


export type MutationRefreshTracksArgs = {
  input: RefreshInput;
};


export type MutationRegisterWebhookArgs = {
  input: RegisterWebhookInput;
};


export type MutationRestoreArgs = {
  input: RestoreFileInput;
};


export type MutationSetupDesktopHostArgs = {
  input: SetupDesktopHostInput;
};


export type MutationStartDesktopHostArgs = {
  input: StartDesktopHostInput;
};


export type MutationStopDesktopHostArgs = {
  input: StopDesktopHostInput;
};


export type MutationTag_FolderArgs = {
  input?: InputMaybe<TagFolderInput>;
};


export type MutationUndeleteArgs = {
  input: FileInput;
};


export type MutationUnmountEditingWorkspaceArgs = {
  input: UnmountEditingWorkspaceInput;
};


export type MutationUpdateFileArgs = {
  input: UpdateFileInput;
};

/** Represents an organization. */
export type Organization = {
  __typename?: 'Organization';
  /** The unique ID of the organization. */
  id: Scalars['ID']['output'];
  /** The legacy/api name of the organization. */
  legacy_name: Scalars['String']['output'];
  /** The name of the organization. */
  name: Scalars['String']['output'];
};

/** The list of organizations the user is a member of. */
export type OrganizationPayload = {
  __typename?: 'OrganizationPayload';
  /** The organization document in JSON format. */
  organizations: Array<Organization>;
};

/** Represents a policy in the system. */
export type Policy = {
  __typename?: 'Policy';
  /** The display name of the policy. */
  display_name: Scalars['String']['output'];
  /** The statements that make up the policy. */
  statements: Array<Statement>;
};

/** Represents the payload/return value of a permission request. */
export type PolicyPayload = {
  __typename?: 'PolicyPayload';
  /** The permission document in JSON format. */
  licensedServices: Array<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  policies: Array<Policy>;
};

/** Input type to the `previewGenerate` mutation. */
export type PreviewGenerateInput = {
  /**
   * The unique identifier for the new folder, expressed as a URL.
   * Example: s3://my-bucket/folder/new-folder
   */
  folder_id: Scalars['ID']['input'];
  /**
   * When force is true the preview proxies are regenerated even if up-to-date
   * proxies already exist for the current source version (otherwise the prepare
   * step skips encoding and reuses the existing proxies).
   */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type to the `previewPrepare` mutation. */
export type PreviewPrepareInput = {
  /**
   * The unique identifier for the new folder, expressed as a URL.
   * Example: s3://my-bucket/folder/new-folder
   */
  folder_id: Scalars['ID']['input'];
  /**
   * When force is true the preview proxies are regenerated even if up-to-date
   * proxies already exist for the current source version.
   */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The PreviewTokenPayload entity holds all the necessary information for playing a preview. */
export type PreviewTokenPayload = {
  __typename?: 'PreviewTokenPayload';
  /** The access token provides authorization for accessing the encrypted DASH or HLS files and their respective manifests. Reference: Token-based Access Control for DASH (TAC). */
  access_token?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the preview's asset, as specified in the previewGenerateToken mutation. */
  asset_id: Scalars['String']['output'];
  /** The HTTPS URL for the DASH manifest, used for playback. */
  dash_url?: Maybe<Scalars['String']['output']>;
  /** The DRMtoday upfront token authorizes the delivery of the required license for playback. */
  drmtoday_token?: Maybe<Scalars['String']['output']>;
  /** The HTTPS URL for the HLS manifest, used for playback. */
  hls_url?: Maybe<Scalars['String']['output']>;
};

/** Represents a long running action performed by the system. */
export type Process = {
  __typename?: 'Process';
  /** The type of action being performed by the process. */
  action: Scalars['String']['output'];
  /** Additional information related to the action performed by the process. This field is typically only set when the process is in a terminal state. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date and time the process ended. */
  end_date?: Maybe<Scalars['AWSDateTime']['output']>;
  /** A unique identifier for the process. */
  id: Scalars['ID']['output'];
  /** A message indicating the progress of the process. This can be used to provide updates on the process' status to the client. */
  message?: Maybe<Scalars['String']['output']>;
  /** The date and time the process was created. */
  start_date?: Maybe<Scalars['AWSDateTime']['output']>;
  /** The current state of the process. */
  state: ProcessStateEnum;
};

/** Input type used to update a process subscription. */
export type ProcessInput = {
  /** Type of action being performed by the process. */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Optional additional information related to the action performed by the process. Typically set only when the process is in a terminal state. */
  data?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the process. */
  id: Scalars['ID']['input'];
  /** Progress message to provide updates on the process status to the client. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Current state of the process. */
  state: ProcessStateEnum;
};

/** Enumeration of possible states of a process. */
export enum ProcessStateEnum {
  /** The process has failed. The `message` and/or `data` property contains further details. */
  Failed = 'FAILED',
  /** The process is still running. The  `message` field contains information about the current state. */
  InProgress = 'IN_PROGRESS',
  /** The process finished successfully. If the process has a result, it will be available in the `data` field. */
  Success = 'SUCCESS'
}

export type Query = {
  __typename?: 'Query';
  /**
   * What a viewer needs to play a CRD session's stream (VTK-3622): the env's DRM mode and, for an encrypted session,
   * the key id and IV of each encrypted track and a fresh DRMtoday upfront token. Call it on every (re)connect.
   */
  crdDrmSession: CrdDrmSession;
  desktopHosts: Array<DesktopHost>;
  /**
   * Returns a list of editing workspaces for the current organization.
   * Organization is determined from the authentication context.
   */
  editingWorkspaces: Array<EditingWorkspace>;
  /** Retrieves information about a specific file, identified by its `id`. */
  file?: Maybe<File>;
  /** Retrieves information about a folder, identified by its `id`. Use `id` value 's3://' to retrieve information about all available buckets. */
  folder?: Maybe<Folder>;
  /** Returns a list of organizations the user is a member of. */
  organizations?: Maybe<OrganizationPayload>;
  /** Returns a PermissionPayload document for the user requesting it. This information can be used to determine which actions should be displayed or hidden in a user interface. */
  policies?: Maybe<PolicyPayload>;
  /** Retrieves information about a specific process, identified by its `id`. */
  process?: Maybe<RepositoryProcessPayload>;
  roots: Array<Folder>;
  search?: Maybe<SearchResults>;
  userProfile?: Maybe<UserProfilePayload>;
};


export type QueryCrdDrmSessionArgs = {
  input: CrdDrmSessionInput;
};


export type QueryDesktopHostsArgs = {
  input: DesktopHostsQueryInput;
};


export type QueryEditingWorkspacesArgs = {
  input: EditingWorkspacesQueryInput;
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProcessArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  input?: InputMaybe<SearchInput>;
};

export type RefreshInput = {
  /** ID of the file. E.g. s3://bucket/path/filename.mp4 */
  file_id: Scalars['ID']['input'];
  /** When force is true the refresh will be performed disregarding any existing values. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterWebhookInput = {
  process_id: Scalars['ID']['input'];
  webhook_url: Scalars['AWSURL']['input'];
};

export type RepositoryProcessPayload = {
  __typename?: 'RepositoryProcessPayload';
  /** The type of action being performed by the process. */
  action?: Maybe<Scalars['String']['output']>;
  /** Additional information related to the action performed by the process. This field is typically only set when the process is in a terminal state. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date and time the process ended. */
  end_date?: Maybe<Scalars['AWSDateTime']['output']>;
  /** A unique identifier for the process. */
  id: Scalars['ID']['output'];
  /** A message indicating the progress of the process. This can be used to provide updates on the process' status to the client. */
  message?: Maybe<Scalars['String']['output']>;
  /** The date and time the process was created. */
  start_date?: Maybe<Scalars['AWSDateTime']['output']>;
  /** The current state of the process. */
  state: ProcessStateEnum;
};

/** Input type for the `restore` Mutation. */
export type RestoreFileInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  /** A list of file IDs to be restored */
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tier?: InputMaybe<RestoreTier>;
};

export enum RestoreState {
  /** The object is archived, not restored and restoration isn't started */
  Archived = 'ARCHIVED',
  /** The archived object is restored. Expiration can be read from the ArchiveState struct */
  Restored = 'RESTORED',
  /** Restoration is in progress. ETA can be read from the ArchiveState struct */
  Restoring = 'RESTORING'
}

export enum RestoreTier {
  RestoreTier_1 = 'RESTORE_TIER_1',
  RestoreTier_2 = 'RESTORE_TIER_2',
  RestoreTier_3 = 'RESTORE_TIER_3'
}

/** The SearchInput input object is used to execute a search query in the system. It defines the parameters for the search query, such as the starting index of the result set, the size of the result set, and the Elasticsearch query in the form of a JSON document. */
export type SearchInput = {
  not_after?: InputMaybe<Scalars['AWSDateTime']['input']>;
  not_before?: InputMaybe<Scalars['AWSDateTime']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  show_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  item: FileOrFolder;
  score: Scalars['Float']['output'];
};

export type SearchResults = {
  __typename?: 'SearchResults';
  items: Array<SearchResult>;
  /** The total number of items that match the search criteria. This may be larger than the number of items returned. */
  total: Scalars['Int']['output'];
};

export type SetupDesktopHostInput = {
  hostInstance: Scalars['String']['input'];
  pool: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type StartDesktopHostInput = {
  hostInstance: Scalars['String']['input'];
  pool: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

/** Represents a statement in a policy. */
export type Statement = {
  __typename?: 'Statement';
  /** The actions that the statement applies to. */
  actions: Array<Scalars['String']['output']>;
  /** The conditions under which the statement is true. */
  conditions?: Maybe<Array<Condition>>;
  /** The effect of the statement, either "allow" or "deny". */
  effect: Scalars['String']['output'];
  /** The resources that the statement applies to. */
  resources?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents a single still image. */
export type Still = {
  __typename?: 'Still';
  /** The human-readable name of the file. */
  name: Scalars['String']['output'];
  /** A signed URL to the actual image file. */
  url: Scalars['AWSURL']['output'];
};

export type StopDesktopHostInput = {
  hostInstance: Scalars['String']['input'];
  pool: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type StopDesktopHostPayload = {
  __typename?: 'StopDesktopHostPayload';
  status: Scalars['String']['output'];
};

/** A Tag represents a key-value pair that is attached to a `File` or `Folder` object. */
export type Tag = {
  __typename?: 'Tag';
  /** The unique identifier for the tag key. */
  key: Scalars['String']['output'];
  /** The corresponding value for the tag key. */
  value: Scalars['String']['output'];
};

/** Input type for the tag_folder mutation. */
export type TagFolderInput = {
  /**
   * The unique identifier for the new folder, expressed as a URL.
   * Example: s3://my-bucket/folder/new-folder
   */
  folder_id: Scalars['ID']['input'];
  /** The tags to be assigned to the folder. */
  tags?: InputMaybe<Array<TagInput>>;
};

/** Represents the payload/return value of the tag_folder mutation. */
export type TagFolderPayload = {
  __typename?: 'TagFolderPayload';
  /** The updated folder object after tagging. */
  folder: Folder;
};

/** Input type for the tag key-value pair. */
export type TagInput = {
  /** The key for the tag. */
  key: Scalars['String']['input'];
  /** The corresponding value for the tag. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the search result of a tag. */
export type TagSearchResult = {
  __typename?: 'TagSearchResult';
  /** The name of the tag. */
  name: Scalars['String']['output'];
  /** The value of the tag. */
  value: Scalars['String']['output'];
};

/** Represents a track within a media file. */
export type Track = {
  __typename?: 'Track';
  /** If disabled, it will not be used for any workflow. */
  enabled: Scalars['Boolean']['output'];
  /** The index of the track as defined by the container format. 0 for raw media files. */
  index: Scalars['Int']['output'];
  /** The language of the track, represented using a BCP-47 code. */
  language: Scalars['String']['output'];
  /** The type of the track, either close caption, subtitle, video, audio, or image. Immutable when audio, video, or image. */
  track_type: TrackType;
};

export type TrackInput = {
  enabled: Scalars['Boolean']['input'];
  index: Scalars['Int']['input'];
  language: Scalars['String']['input'];
  track_type: TrackType;
};

export enum TrackType {
  Audio = 'audio',
  Closedcaption = 'closedcaption',
  Data = 'data',
  Image = 'image',
  Subtitle = 'subtitle',
  Video = 'video'
}

export enum UnmountAction {
  CopyBack = 'COPY_BACK',
  Delete = 'DELETE',
  Unmount = 'UNMOUNT'
}

export type UnmountEditingWorkspaceInput = {
  action: UnmountAction;
  id: Scalars['ID']['input'];
  pool: Scalars['String']['input'];
};

/** Input type for `updateFile` mutation. */
export type UpdateFileInput = {
  /** ID of the file. E.g. s3://bucket/path/filename.mp4 */
  file_id: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  tracks?: InputMaybe<Array<InputMaybe<TrackInput>>>;
};

/** Generic input type for several more specific file update mutations. */
export type UpdateFilePayload = {
  __typename?: 'UpdateFilePayload';
  file: File;
};

export type UploadTicketPayload = {
  __typename?: 'UploadTicketPayload';
  directory: Scalars['String']['output'];
  expiration: Scalars['AWSDateTime']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UserProfilePayload = {
  __typename?: 'UserProfilePayload';
  /** Email address of the user. */
  email: Scalars['String']['output'];
  /** Name of the user. */
  name: Scalars['String']['output'];
  /** Staff yes/no status of the user. */
  staff: Scalars['Boolean']['output'];
};
